import { Link } from "@inertiajs/react";
import { memo } from "react";

import ChevronRightIcon from "@/Icons/chevron_right.svg?react";
import ExploreIcon from "@/Icons/compass.svg?react";
import HomeIcon from "@/Icons/home_active.svg?react";

export type BB_PageLink = {
	id?: string | null;
	name: string;
	href?: string | null;
};

export type BB_BreadcrumbsProps = {
	pages: BB_PageLink[];
	className?: string;
};

const stickyNav = false;

const BB_Breadcrumbs = (props: BB_BreadcrumbsProps) => {
	return (
		<nav
			className={`${props.className ?? ""} z-20 select-none ${stickyNav ? "sticky top-16 sm:relative sm:top-0" : "relative"} my-4 flex`}>
			<div className="from-background-100 dark:from-dark-background-300 pointer-events-none absolute top-0 left-0 block h-full w-6 bg-gradient-to-r to-transparent sm:hidden" />
			<ol className="bg-background-50 sm:bg-background-100 dark:bg-dark-background-300 scrollbar-hide flex w-full gap-2 overflow-x-auto rounded-none px-4 py-2 whitespace-nowrap sm:w-auto sm:gap-2.5 sm:rounded-lg sm:shadow-lg">
				<li className="flex">
					<div className="flex items-center">
						<Link href={route("home")} className="text-gray-400! hover:text-gray-500!">
							<HomeIcon className="h-5 w-5 shrink-0" aria-hidden="true" />
						</Link>
					</div>
				</li>
				{props.pages.map((page, index) => (
					<li key={"b_" + page.id + "_" + index.toString()} className="flex">
						<div className="flex items-center">
							<ChevronRightIcon
								className="mr-2 h-4 w-4 shrink-0 text-gray-400 sm:mr-2.5"
								aria-hidden="true"
							/>
							<Link
								href={page.href ?? route("explore")}
								className={`text-sm font-medium text-gray-400! hover:text-gray-500! ${!page.href ? "opacity-70🔥 pointer-events-none dark:opacity-50" : ""}`}>
								{page.id === "explorePage" ? (
									<div className="flex gap-2">
										<ExploreIcon
											className="h-5 w-5 shrink-0"
											aria-hidden="true"
										/>
										{index + 1 === props.pages.length && (
											<span>{page.name}</span>
										)}
									</div>
								) : (
									<span>{page.name}</span>
								)}
							</Link>
						</div>
					</li>
				))}
			</ol>
			<div className="from-background-100 dark:from-dark-background-300 pointer-events-none absolute top-0 right-0 block h-full w-6 bg-gradient-to-l to-transparent sm:hidden" />
		</nav>
	);
};

export default memo(BB_Breadcrumbs);
